import type { GatewayStatus, InstallationStatus } from "@/contracts";
import {
  IconAntennaOff,
  IconCircleCheck,
  IconFlagOff,
  IconPlayerPlay,
  IconQuestionMark,
  IconWifi,
  IconWifiOff,
} from "@tabler/icons-react";

import { Badge } from "@/components/ui/badge";
import {
  GATEWAY_STATUS_LABELS,
  GATEWAY_STATUS_TONES,
  INSTALLATION_STATUS_LABELS,
  INSTALLATION_STATUS_TONES,
} from "./gateway-labels";

export function GatewayStatusBadge({ value }: { value: GatewayStatus }) {
  const icon =
    value === "ONLINE" ? IconWifi : value === "OFFLINE" ? IconWifiOff : IconQuestionMark;

  return (
    <Badge tone={GATEWAY_STATUS_TONES[value]} icon={icon}>
      {GATEWAY_STATUS_LABELS[value]}
    </Badge>
  );
}

export function InstallationStatusBadge({ value }: { value: InstallationStatus }) {
  const icon =
    value === "COMMISSIONED"
      ? IconCircleCheck
      : value === "AWAITING_UPLINK"
        ? IconPlayerPlay
        : value === "FAILED"
          ? IconFlagOff
          : IconAntennaOff;

  return (
    <Badge tone={INSTALLATION_STATUS_TONES[value]} icon={icon}>
      {INSTALLATION_STATUS_LABELS[value]}
    </Badge>
  );
}
